export enum AssetSort {
    tokenId = 'token_id',
    saleDate = 'sale_date',
    saleCount = 'sale_count',
    visitorCount = 'visitor_count',
    totalPrice = 'total_price',
    salePrice = 'sale_price'
}
